// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopupTemplateHead_wrapper__1x4BK","p":"PopupTemplateHead_p__-nA1b"};